import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'tableName',
      type: 'input',
      label: '表名',
      placeholder: '请输入表名'
    },
    {
      field: 'tableComment',
      type: 'input',
      label: '表中文名',
      placeholder: '请输入表中文名'
    }
  ]
}
